// extracted by mini-css-extract-plugin
export default {"spinner_div":"LoadingSpinner_spinner_div__zOGP9","spinner":"LoadingSpinner_spinner__m-3xK"};